<template>
  <div>
    <v-row>
      <v-col>
        <general-info :id="prisonerId" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card>
          <iapsz :id="prisonerId" />
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <cra :id="prisonerId" />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import { APIService } from "@/http/APIService.js";
import GeneralInfo from "./components/GeneralInfo.vue";
import Cra from "./components/Cra.vue";

// const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    "general-info": GeneralInfo,
    cra: Cra,
  },
  data: () => ({}),

  computed: {
    prisonerId() {
      return this.$route.params.id;
    },
  },

  created() {},

  methods: {},
};
</script>